import {createRouter as createVueRouter, createWebHashHistory} from "vue-router"
import Alumno from '@/views/Alumno.vue'
import Login from '@/views/Login.vue'
import Aviso from '@/views/Aviso.vue'
import MenuEntrada from "../views/MenuEntrada.vue";
import Registro from "../views/Registro.vue";
import Matricula from "../views/Matricula.vue";

// Genero wrapper para createRouter de manera que pueda recibir la referencia de app y
// tener accesible la globalProperties
const createRoutes = (app) => [
    {
        path: '/',
        name: 'menu-entrada',
        component: MenuEntrada,
    },
    {
        path: '/expedientes',
        name: 'alumno',
        component: Alumno,
    },
    {
        path: '/entrada',
        name: 'login',
        component: Login,
        beforeEnter(to, from, next) {
            // eslint-disable-next-line no-undef
            if (sessionStorage.getItem(app.config.globalProperties.$nombreToken) !== null) {
                next({name: 'menu-entrada'});
            } else {
                next();
            }
        },
    },
    {
        path: '/registro',
        name: 'registro',
        component: Registro,
    },
    {
        path: '/matricula',
        name: 'matricula',
        component: Matricula,
    },
    {
        path: '/aviso',
        name: 'aviso',
        component: Aviso,
    },
]

export const createRouter = (app) => {
  return createVueRouter({
    history: createWebHashHistory(),
    routes: createRoutes(app),
  })
}
